/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { MessageDetails } from '../../../core/model/message-details.model';
import { MessageHandlerService } from '../../../core/services/message-handler.service';

/**
 * @export
 * @class LmsMessageComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-message',
  templateUrl: './lms-message.component.html',
  styleUrls: ['./lms-message.component.scss']
})
export class LmsMessageComponent implements OnInit, OnDestroy {

  @Input() target: string;

  messageDetails: MessageDetails;

  messageSubscription: any;

  private timeOutHandler: any;

  /**
   * Creates an instance of LmsMessageComponent.
   * @param {MessageHandlerService} messgaeService
   * @memberOf LmsMessageComponent
   */
  constructor(private messgaeService: MessageHandlerService) {
    this.messageSubscription = this.messgaeService.messageObservable.subscribe(data => {
      this.messageDetails = <MessageDetails>(data);
      if (this.messageDetails && (this.messageDetails.level === 'info' ||
        this.messageDetails.level === 'success')) {
        if (this.timeOutHandler) {
          clearTimeout(this.timeOutHandler);
        }
        this.timeOutHandler = setTimeout(() => { this.messageDetails = null; }, 10000);
      }
    });
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LmsMessageComponent
   */
  ngOnInit() {
  }

  /**
   * this method is used to close the error message
   * when user click on cross(X) icon.
   * @memberOf LmsMessageComponent
   */
  public closeErrorMessage() {
    this.messageDetails = null;
    if (this.timeOutHandler) {
      clearTimeout(this.timeOutHandler);
    }
  }

  /**
   * Life cycle hook to clean the states
   * @memberOf LmsMessageComponent
   */
  ngOnDestroy() {
    this.messageSubscription.unsubscribe();
  }

}
